// Formats
export const FORMAT = {
    CHECK: 1,
    YESNO: 2,
    YESNONC: 3,
    TEXT: 4,
    PHOTO: 5,
    NUMBER: 6,
    DATE: 7,
    TITLE: 8,
    SUBTITLE: 9,
    TEXTAREA: 10,
    MULTIPLE: 11, // selector type
    TIME: 12,
    DATETIME: 13,
    SIGNATURE: 14,
    TEMPERATURE: 15,
    EMAIL: 16,
    DOCUMENT: 17,
    MESSAGE: 18,
    LINK: 19,
    RESOURCE: 20
}

export const LABEL_STEP_TYPE = {
    IMAGE: 'image',
    TEXT: 'text',
    BARCODE: 'barcode',
    DAYS: 'days'
}

export const TYPE = {
    TASK: 1,
    AUDIT: 2,
    RECORD: 3,
    ISSUE: 4,
    ACTION_PLAN: 5
}

export const TOOLS = {
    CHECKLISTS: 1,
    ISSUES: 2,
    LABELS: 3,
    REGISTERS: 4,
    LIBRARY: 5,
    TRAINING: 6,
    AUDITS: 7,
    EXTERNAL_TOOLS: 8,
    TICKETS: 9,
    LOGBOOK: 10,
    DIGITAL_LABEL: 11,
    CREATE_INGR_LABELS: 12,
    ACTION_PLANS: 19,
    SENSORS: 13,
    OPERATIONAL_TIMERS: 15,
    PRODUCT_TIMERS: 16,
    ALLERGENS: 23
}

export const TYPE_STORE = {
    TASK: 'tasks',
    AUDIT: 'audit',
    RECORD: 'register',
    ISSUE: 'issues'
}

export const TIMERPRODUCT_STATUS = {
    EXPIRED: 0,
    AVAILABLE: 2,
    PREPARATION: 1,
    CLOSE_TO_EXPIRE: 3
}

/**
 * Variantes visuales de recomendaciones de Andy (BUILD-7486).
 * BUILD-7490 decide cuál mostrar; este mapa solo nombra estados de UI.
 */
export const RECOMMENDATION_VARIANT = {
    DELETE_EXPIRED: 'delete-expired',
    COMBINED: 'combined',
    ADD_PRODUCTS: 'add-products'
}

/**
 * Config local del motor de recomendaciones Andy (BUILD-7490).
 * Umbral y prioridad viven en frontend; no hay backend.
 */
export const RECOMMENDATION_TRIGGERS = {
    /** “Más de N” productos expirados en Desechar. */
    expiredThreshold: 5,
    priority: [RECOMMENDATION_VARIANT.COMBINED, RECOMMENDATION_VARIANT.DELETE_EXPIRED, RECOMMENDATION_VARIANT.ADD_PRODUCTS]
}

/** BUILD-6983: store tick while on timer screens vs background */
export const TIMER_TICK_FAST_MS = 1000
export const TIMER_TICK_SLOW_MS = 60 * 1000

export const SORT = {
    ASCENDING: 1,
    DESCENDING: 2,
    NO_ORDER: 3
}

export const ACTION_TYPE = {
    NOT_APPLY: 0,
    APPLY: 1
}

export const RBE_PREFIXES = [
    'bkes', 'plkes', 'plkit', 'bkpt', 'rbe-dev'
]

export const RADAR_EXECUTION_INTERVAL_MS = 1 * 60 * 1000 // 1 minute
// export const RADAR_EXECUTION_INTERVAL_MS = 10 * 1000 // pruebas locales

/** Evento de sesión APP (Trigger -> Tracked Event en Refiner). Independiente de panel_session_started. */
export const REFINER_SESSION_EVENT = 'app_session_started'
export const REFINER_SESSION_TRACKED_KEY = 'refiner_app_session_tracked'
export const REFINER_SESSION_TRACK_DELAY_MS = 1200
export const REFINER_EVENT_AFTER_SESSION_DELAY_MS = 500